import { IProduct } from './models/product.model';
import productsJson from './data/generic-products.data.json';
import { toLookup } from './helpers/utils.helpers';

export const genericProducts = productsJson as IProduct[];
export const genericProductsLookup = toLookup(genericProducts);

export default genericProducts;
